export enum Tabs {
  Activation = 'Activation',
  Access = 'Access',
}

export const FILE_INPUT_EMPTY_MESSAGE = 'SVG, PNG, JPG or GIF (max. 3MB)';
